import React from "react";
import { Container } from "@KristianIV/common-ui";
import AppNav from "./AppNav";
import NotificationOverlay from "../status/NotificationOverlay";
import styles from "./PageLayout.module.css";

/** Page frame for pages built on common-ui: the library Container, the nav, and the popup overlay. */
const PageLayout = ({ children }: { children: React.ReactNode }) => (
  <Container className={styles.page}>
    <AppNav />
    <NotificationOverlay />
    <main className={styles.content}>{children}</main>
  </Container>
);

export default PageLayout;
